import { createStyle } from '@gluestack-style/react';

export const AccordionHeader = createStyle({
  mx: '$0',
  my: '$0',
});
